// extracted by mini-css-extract-plugin
export default {"container":"jTpW3WKE","mobile":"mobile","logos":"FozBlUYT","title":"J3UpZXNK","buttons":"gUTTVf18","description":"FGu5tQDD","agreement":"sLsHJSu6"};